import * as React from "react";
import Octicon, { getIconByName } from '@github/octicons-react'; //https://octicons.github.com/

class ModalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            title: '',
            bodyMessage: '',
            footerChild: null,
            iconName: '',
            titleClassName: '',
            onCloseClick: null
        };
    }

    handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            if (this.props.enterKeyDown)
                this.props.enterKeyDown();
            else
                document.getElementById('closeModal' + this.props.id).click();
        }
    };

    render() {
        const iconInfo = this.props.iconName
            ? <Octicon icon={getIconByName(this.props.iconName)} size='medium' className='ml-1 mr-2' ariaLabel={this.props.iconName} />
            : '';

        const title = this.props.title
            ? this.props.title
            : 'Dialog';

        return (
            <div className='modal fade' id={this.props.id} tabIndex='-1' role='dialog' aria-labelledby='exampleModalCenterTitle' aria-hidden='true' data-backdrop='false' focus='true' onKeyDown={(e) => { this.handleKeyDown(e); }}>
                <div className='modal-dialog modal-dialog-centered' role='document'>
                    <div className={'modal-content ' + this.props.className}>
                        <div className='modal-header'>
                            <h3 className={'modal-title ' + this.props.titleClassName} id='exampleModalCenterTitle' tabIndex='-1' >
                                {iconInfo}
                                {title}
                            </h3>
                            <button id={'closeModal' + this.props.id} type='button' className='close' data-dismiss='modal' aria-label='Close' onClick={this.props.onCloseClick} >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                        <div className='modal-body' dangerouslySetInnerHTML={this.renderBody()} />
                        <div className='modal-footer'>
                            {this.props.footerChild}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderBody() {
        return { __html: (this.props.bodyMessage) };
    }
}

export default ModalDialog;


// WEBPACK FOOTER //
// ./src/components/Controls/ModalDialog.js